module.exports = __webpack_public_path__ + "img/image25.404d206e.png";